<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des mouvements</h3>
    </div>
    
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >   
    
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
     
      <div class="col-md-12">
      <div class="row">          
          <!-- <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Mot clé
              </label>
              <Field 
                style="max-height: 42px;"
                v-model="searchTerm"
                @keyup="rechercher" 
                name="mot" 
                type="text" 
                aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black" 
                placeholder="Recherche par mot clé"/>
            </div>
          </div> -->
    <div class="col-md-3" v-if="point_ventes.length > 1">
    <div class="form-group mb-15 mb-sm-20 mb-md-25">
      <label class="d-block text-black fw-semibold mb-10">
       Filtrer par Point de vente
      </label>
      <div class="d-flex align-items-center" style="width: 200px;">
        <Multiselect 
         
          v-model="point_vente" 
          :options="point_ventes"  
          :searchable="true" 
          track-by="label" 
          label="label" 
          placeholder="Sélectionner un point de vente" 
        />
      </div>
    </div>
  </div> 
  <div class="col-md-3">
              <div class="form-group ">
                  <label class="d-block text-black fw-semibold mb-10">
                      Type Operation 
                  </label>
                  <Multiselect :searchable="true" :options="lestypes"  v-model="_type"
                    placeholder="Choisir" />
              </div>
          </div>
          <div class="col-md-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Magasin 
              </label>
                <Multiselect
                  :options="magasinOptions" 
                  :searchable="true"
                  v-model="_magasin"
                  placeholder="Sélectionner le magasin"
                />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Produit 
              </label>
                <Multiselect
                  v-model="_produit" 
                  :options="produitOptions" 
                  :searchable="true"
                  :disabled="prodEtat"
                  placeholder="Sélectionner un produit"
                />
            </div>
          </div>
          <!--<div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Motif d'Opération
              </label>
                <Multiselect
                  v-model="_motif"
                  :options="motifSuiviOptions" 
                  :searchable="true"
                  placeholder="Sélectionner le motif"
                />
            </div>
          </div>-->
      </div>
      </div>
      <hr>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Produit 
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Magasin
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Quantite
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Type Opération 
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Motif
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Référence
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Statut
              </th>
             <!-- <th scope="col"  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >Actions</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(mouvement, index) in mouvements" :key="index">
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement.proCondiMagInventaire?.nomProd }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                  {{ mouvement.proCondiMagInventaire?.procondimag?.magasin?.nomMagasin }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement.qte }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement.typeOperation }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement?.motifsSuivi?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ mouvement?.refMov }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                <div v-if="mouvement.statut === 0">
                  <span class="badge badge-danger">En attente</span>
                </div>
                <div v-if="mouvement.statut === 1">
                  <span class="badge badge-success">Valider</span>
                </div>
              </td>
              <!--<td
              class="shadow-none lh-1 fw-medium text-end pe-0 sm">
              <div class="dropdown">
                <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">Actions</button>
                  <ul class="dropdown-menu">
                      <li v-if="checkPermission('ValidMouvement')">
                          <a @click="valider(mouvement.id)" class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                              <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>Valider
                          </a>
                      </li>
                       <li v-if="checkPermission('DeleteMouvement')">
                          <a @click="suppression(mouvement.id, mouvements, 'mouvements', 'mouvement')" class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                              <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>Supprimer
                          </a>
                      </li>
                  </ul>
              </div>
              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      <hr/>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from "@/services/ApiService";
import { useRouter } from 'vue-router';
import { Mouvements } from "@/models/Mouvement";
import { format_date,suppression,format_Date, hideModal, showModal,separateur, error,success,optionPointVente } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
    name: "ListeMouvement",
    components: {
      Form,
      Field,
      Multiselect,
      PaginationComponent,
  },
  setup: () => {
    
    let point_vente = ref<string>("");
    let point_ventes = ref([]);

    const mouvements = ref<Array<Mouvements>>([]);
    const mouvement = ref<Mouvements>();
    const produitOptions = ref([]);
    const magasinOptions = ref([]);
    const magasin = ref([]);
    const produit = ref([]);
    const selectedEtat = ref('');
    const prodEtat = ref(true);

    // BEGIN PAGINATE
    const _produit = ref('');
    const _magasin = ref('');
    const magasins = ref();
    const _bureau = ref('');
    const _type = ref('');
    const _motif = ref('');
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const router = useRouter();

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllMouvements(page_, limit_);
      } catch (error) {
        //
      }
    };
    const motifSuiviOptions = ref([])

    const fetchMotifSuivi = async () => {
    try {
      const response = await ApiService.get("/all/motifSuivis");
      const invData = response.data.data.data;
      motifSuiviOptions.value = invData.map((inv) => ({
        value: inv.id,
        label: `${inv.libelle}`,
      }));
    } catch (error) {
      //
    }
  };

  const lestypes = ref([
      { value: "Entrée", label: "Entrée" },
      { value: "Sortie", label: "Sortie" }
    ]);


    watch(_produit, () => {
      rechercher();
    });

    watch(_type, () => {
      rechercher();
    });

    watch(_motif, () => {
      rechercher();
    });

    watch(point_vente, () => {
      rechercher();
    });

    watch(_magasin, async (newValue, oldValue) => {
      rechercher();
      if(newValue != oldValue){
       await fetchProduits(newValue)
      }
    });

    // watch(_magasin, () => {
    //   rechercher();
    // });

    watch(selectedEtat, () => {
      if(selectedEtat.value == 'Tout')
        selectedEtat.value='';
      rechercher();
    });

    function rechercher(){
      getAllMouvements(point_vente.value, page.value, limit.value, searchTerm.value, _motif.value, _magasin.value, _produit.value, selectedEtat.value, _type.value );
    }

    const fetchProduits = async (magasin:any) => {
      ApiService.get(`/produits/${magasin}/prodMag`)
      .then(({ data }) => {
        console.log("TTTTTTTTTTTTTT ===> ",data);
        const donnees = data.data;
        if(donnees && donnees.length > 0){
          prodEtat.value = false
        }else{
          prodEtat.value = true;
        }
        produitOptions.value = donnees.map((produit) => {
          return {
            value: produit.id,
            label: produit.produitcondi.produit.nomProd + `[ ${produit.produitcondi.conditionnement.libelle} ]`,
          }
        });
      })
      .catch(({ response }) => {
        console.log("TYYYTYYTYTYT ===> ", response)
        // error(response.data.message)
      });
    }


    const fetchMagasins = async () => {
      ApiService.get("all/all/magasins")
      .then(({ data }) => {
        const donnees = data.data;
        magasinOptions.value = donnees.map((magasin) => {
          return {
            value: magasin.id,
            label: magasin.code + ' - ' + magasin.nomMagasin + ' du ' + magasin.magasin.nomMagasin,
          }
        });
      })
      .catch(({ response }) => {
        // error(response.data.message)
      });
    }

    
    const recharger = () => {
      getAllMouvements(point_vente.value);
    };

    function getAllMouvements(point_vent, page = 1, limi = 10, searchTerm = '', _motif = '', _magasin = '' , _produit = '' , selectedEtat = '', type="") {
      return ApiService.get(`/mouvements?page=${page}&limit=${limi}&mot=${searchTerm}&motif=${_motif}&magasin=${_magasin}&produit=${_produit}&etat=${selectedEtat}&type=${type}&pointvente=${point_vent}&`)
        .then(({ data }) => {
          mouvements.value = data.data.data
          console.log("MOOOOOOOOOUUUUUUUUUVE ===>", mouvements.value);
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          // error(response.data.message);
        });
    }

    const valider = async(id:any)=>{
      Swal.fire({
        text: `Vous êtes sur le point de valider le mouvement n°${id}.\n Etes-vous sûr ?`,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Valider",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton:"btn btn-danger"
        },
      }).then(async(result) => {
        try {
            if (result.isConfirmed) {
            const response = await ApiService.put("/mouvements/statut/"+id, {})
            if (response.data.code == 200) {
              success(response.data.message);
              router.push({ name: "ListeMouvement" });
            }
          }else{
            error("Vous avez annulé la soumission");
          }
          
        } catch (response) {
          error(response.message);
        }
      })
}

    onMounted(async() => {
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];
      getAllMouvements(point_vente.value);
      fetchMagasins();
      fetchMotifSuivi();
      //getAllMagasin();
    });

    

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
    
    return { 
      mouvements,
      checkPermission,
      produitOptions,
      magasinOptions,
      format_date,
      suppression,
      getAllMouvements, 
      page, 
      totalPages,
      limit,
      format_Date,
      totalElements,
      handlePaginate,
      valider,
      _type,
      _motif,
      lestypes,
      separateur,
      searchTerm,
      _bureau,
      prodEtat,
      _magasin,magasins,
      _produit,magasin,produit,
      rechercher,
      Multiselect,
      motifSuiviOptions,
      selectedEtat,
      recharger,
      point_ventes,
      point_vente
    };
  },
});
</script>

